<div class="seg-job-roles-widget">
  @if (profiles?.length) {
    @for (seg of profiles!; track trackByIndex($index)) {
      <div [style]="styles.section">
        <div [style]="styles.subHeading">{{ seg.segName }} — {{ labels.heading }}</div>
        @if (seg.jobRoles.length) {
          <table [style]="styles.table">
            <thead>
              <tr>
                <th [style]="styles.headerCell">{{ labels.role }}</th>
                <th [style]="styles.headerCell">{{ labels.samples }}</th>
              </tr>
            </thead>
            <tbody>
              @for (role of seg.jobRoles; track trackByIndex($index)) {
                <tr>
                  <td [style]="styles.cell">{{ role.roleName }}</td>
                  <td [style]="styles.cell">{{ role.sampleCount }}</td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p [style]="styles.noData">{{ labels.noData }}</p>
        }
      </div>
    }
  } @else {
    <p [style]="styles.noData">{{ labels.noData }}</p>
  }
</div>
